// ----------------------------------------------------------------------
export var Typography = function Typography() {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: 16
        },
        gutterBottom: {
          marginBottom: 8
        }
      }
    }
  };
};